import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-code-of-parents',
  templateUrl: './code-of-parents.component.html',
  styleUrls: ['./code-of-parents.component.css']
})
export class CodeOfParentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
